export const emptyProductId = 'empty';
